module.exports = __webpack_public_path__ + "Simple-Line-Icons.de8ad55bfeaebbe67c5b.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.svg?-i3a2kk
// module id = ../../../../../src/assets/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.svg?-i3a2kk
// module chunks = styles